import { deleteFile } from 'api/file';
import React from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';

const DeleteFileConfirmation = ({ data, setShowDeleteFileModal }) => {

  const queryClient = useQueryClient();

  const { mutate: deleteFileMutation, isLoading: deletingDoc } = useMutation(deleteFile,
    {
      onSuccess: () => {
        queryClient.invalidateQueries('getUserFiles');
        toast.success('Document deleted');
        setShowDeleteFileModal(false);
      },
      onError: () => {
        toast.error('Failed to delete Document');
      },
      onSettled : () => {
        setShowDeleteFileModal(false);  
      }
    }
  );

  return (
    <>
      <div className="text-xl text-center font-semibold my-10 z-30">
        <p>Are you sure you want to delete <span className='text-blue5'>{data.docName}</span> Document?</p>
        <p>This action cannot be undone.</p>
      </div>
      <div className="flex justify-center w-full">
        <div className="flex items-center gap-4">
          <button
            onClick={() => {
              deleteFileMutation(data.docId)
            }}
            disabled={deletingDoc}
            className="bg-green px-8 py-2 rounded-lg border border-solid border-grey"
          >
            {!deletingDoc ? 'Yes' : 'Deleting...'}
          </button>
          <button
            disabled={deletingDoc}
            onClick={() => setShowDeleteFileModal(false)}
            className="bg-red4 px-8 py-2 rounded-lg border border-solid border-grey"
          >
            No
          </button>
        </div>
      </div>
    </>
  );
};

export default DeleteFileConfirmation;
